import React, { PropTypes } from 'react';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';

export default class VisibilitySection extends React.Component {

	state = {
		selectedOption: null
	};

	componentWillMount() {

		if (this.props.isEdit === false) {
			this.userin = true;
		} else {
			this.props.userGroupAccess.forEach((g) => {
				this.props.docGroup.forEach((h) => {
					if (g.id === h.id) {
						this.userin = true;
					}
				});
			});
		}

		//editing document
		if (this.userin === true && this.props.isEdit === true) {
		
			this.props.userGroupAccess.forEach((g) => {
				this.options.push({ value: g.id, label: g.name });
			});
			this.setState( { selectedOption: { value: this.props.docGroup[0].id, label: this.props.docGroup[0].name } } );

		//creating document
		} else if (this.userin === true && this.props.isEdit === false) {
			let url = window.location.href;
			this.props.userGroupAccess.forEach((g) => {
				if ( url.includes("mariana")) {
					if ( g.idProjeto !== 2) {
						this.options.push({ value: g.id, label: g.name });
					}
				} else if ( url.includes("brumadinho")) {
					if ( g.idProjeto !== 1) {
						this.options.push({ value: g.id, label: g.name });
					}
				}
			});
		}
	}

	options = [];
	userin = false;

	handleChange = selectedOption => {
		this.setState({ selectedOption });
		this.props.docGroup[0] = { id: selectedOption.value, name: selectedOption.label };
	};
	selecionaOFalse() {
		
	}
	render () {
		const fullUrl = window.location.href;
		try {
			if (this.props.isEdit === false) {
				
				if ( fullUrl.includes("mariana")) {
					this.props.project[0] = {id: 1, name: "Mariana"};
				} else if ( fullUrl.includes("brumadinho")) {
					this.props.project[0] = {id: 2, name: "Brumadinho"};
				}
			} else {
				this.props.project[0] = { id: this.props.project[0].id, name: this.props.project[0].name };
			}
		} catch (error) {
			const docId = fullUrl.split("/").pop();
			window.alert("Problema com projeto do arquivo. Por favor, contactar o suporte fornecendo a seguinte ID: " +
						docId);
			window.location.pathname = "/admin/documents/view/";
			// LINHA ABAIXO NAO EH SEGURA!!!
			// POSSIVEL PERDA DE INFORMACAO
			// this.props.deleteDocument(docId);
		}
		
		const { selectedOption } = this.state;

		return (
			<div>
				<div className="row">
					<div className="col-md-4">
						<div className="form-group">
							<label>Este documento foi produzido pela COPPE?</label>
							&nbsp;&nbsp;
							<i
								className="fa fa-info-circle pointer"
								data-tip="Em caso negativo, este documento estará aberto a todos os usuários do sistema"
							/>
							<br />
							<label className="radio-inline">
								<input
									type="radio"
									checked={this.props.hasOwner}
									onChange={() => this.props.setHasOwner(true)}
								/>
								Sim
							</label>
							<label className="radio-inline">
								<input
									type="radio"
									checked={!this.props.hasOwner}
									onChange={() => {
										this.props.setHasOwner(false);
										this.props.setIsPublic(true); // Force hasOwner = false to imply isPublic = true
									}}
								/>
								Não
							</label>
						</div>
						<ReactTooltip />
					</div>
					<div className="col-md-3"
							style={{
								display: this.props.hasOwner && this.userin === true? 'block'
								: 'none'}}>
						<div className="form-group">
							<label>Grupo</label>
							&nbsp;&nbsp;
							<i 	className="fa fa-info-circle pointer"
								data-tip="Selecione o grupo que poderá ver e/ou editar este documento"
							/>
							<Select
								name="permissions-select"
								value={selectedOption}
								options={this.options}
								isRequired
								clearable={false}
								searchable={false}
								placeholder="Selecione..."	
								clearAllText="Limpar opções"
								onChange={this.handleChange}>
								<option value="" selected disabled hidden>Choose here</option>
							</Select>
						</div>
						<ReactTooltip />
					</div>
				</div>
			</div>

		);
	}
}

VisibilitySection.propTypes = {
	deleteDocument: PropTypes.func.isRequired,
	isEdit: PropTypes.bool.isRequired,
	setHasOwner: PropTypes.func.isRequired,
	setIsPublic: PropTypes.func.isRequired,
	hasOwner: PropTypes.bool.isRequired,
	isPublic: PropTypes.bool.isRequired,
	project: PropTypes.array.isRequired,
	docGroup: PropTypes.array,
	userProjectAccess: PropTypes.array.isRequired,
	userGroupAccess: PropTypes.array.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/VisibilitySection.js